export default __webpack_public_path__ + "static/media/applogo.bb2fd0c1.png";